<template>
  <section id="section-cadastrar mx-auto">
    <div class="container-fluid m-0 p-0">
      <header-public />
      <div class="row m-0">
        <div class="col-md-12 p-0">
          <form-wizard v-if="dados && selectedPlano" :startIndex="0" color="#0074D9" :stepSize="stepSize" ref="wizard"
            :title="''" :subtitle="''" shape="circle">
            <p class="callout alert-light m-0">Preencher os dados abaixo para contratação da Plataforma de Assinatura
              Eletrônica e Gerenciamento de Documentos Digitais.</p>
            <tab-content :title="getTitle('Assinatura')" icon="fa fa-calendar">
              <div class="row align-items-center callout-x my-3 mx-0 pt-0 pb-5">
                <div class="col-md-8 mx-auto">
                  <register-asign ref="RegisterAsign" v-bind="{dados, selectedPlano}" />
                </div>
                <div class="p-0 my-5 col-md-4 col-lg-3 my-md-0">
                  <register-store v-bind="{dados, selectedPlano}" />
                </div>
              </div>
            </tab-content>
            <tab-content :before-change="validatePersonal" :title="getTitle('Dados Pessoais')" icon="fa fa-list-alt">
              <div class="row align-items-center callout-x my-3 mx-0">
                <div class="col-md-8 mx-auto">
                  <register-personal ref="TabPersonal" v-bind="{dados}" />
                </div>
                <div class="p-0 my-5 col-md-4 col-lg-3 my-md-0">
                  <register-store v-bind="{dados, selectedPlano}" />
                </div>
              </div>
            </tab-content>
            <tab-content :before-change="validateCompany" :title="getTitle('Dados Empresa')" icon="fa fa-building">
              <div class="row align-items-center callout-x my-3 mx-0">
                <div class="col-md-8 col-lg-9 mx-auto">
                  <register-company ref="TabCompany" v-bind="{dados, send}" />
                </div>
                <div class="p-0 my-5 col-md-4 col-lg-3 my-md-0">
                  <register-store v-bind="{dados, selectedPlano}" />
                </div>
              </div>
            </tab-content>
            <tab-content :title="getTitle('Adicionais')" icon="fa fa-plus">
              <div class="row align-items-center callout-x my-3 mx-0">
                <div class="col-md-8 mx-auto">
                  <register-plus v-bind="{dados, selectedPlano}" />
                </div>
                <div class="p-0 my-5 col-md-4 col-lg-3 my-md-0">
                  <register-store v-bind="{dados, selectedPlano}" />
                </div>
              </div>
            </tab-content>
            <tab-content :title="getTitle('Pagamento')" icon="fa fa-check">
              <div class="row align-items-center callout-x my-3 mx-0">
                <div class="col-md mx-auto alert-light rounded">
                  <card-form ref="TabPayment" :payment="dados.selected" />
                </div>
                <div class="p-0 my-5 col-md-4 col-lg-3 my-md-0">
                  <register-store v-bind="{dados, selectedPlano}" />
                </div>
              </div>
              <p class="callout alert-light w-100 mt-3 mb-0">
                Após a confirmação será enviado um e-mail de boas-vindas com instruções de acesso e link para nosso
                canal de treinamento.</p>
            </tab-content>
            <button type="button" class="btn-wizard btn btn-danger" slot="prev"> VOLTAR </button>
            <button type="button" class="btn-wizard btn btn-primary mx-0 mr-md-5" slot="next"> PROXIMO
              <i v-show="dados.loading" @click="send" class="fa fa-circle-o-notch fa-spin"></i>
            </button>
            <button @click="send" type="button" :disabled="dados.loading" class="btn-wizard btn btn-success mx-0 mr-md-5"
              slot="finish"><i class="fa fa-check mx-2"></i>
              CONFIRMAR
              <i v-show="dados.loading" class="fa fa-circle-o-notch fa-spin mx-2"></i>
            </button>
          </form-wizard>
        </div>
      </div>
      <footer-public />
    </div>
  </section>
</template>

<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import HeaderPublic from './components/header-public.vue';
  import RegisterAsign from '../home/components/register-asign.vue';
  import RegisterPersonal from '../home/components/register-personal.vue';
  import RegisterCompany from '../home/components/register-company.vue';
  import RegisterPlus from '../home/components/register-plus.vue';
  import CardForm from '../home/components/card-form.vue';
  import RegisterStore from '../home/components/register-store.vue';
  import FooterPublic from './components/footer-public.vue';
  export default {
    components: {
      FormWizard,
      TabContent,
      HeaderPublic,
      RegisterAsign,
      RegisterPersonal,
      RegisterCompany,
      RegisterPlus,
      CardForm,
      RegisterStore,
      FooterPublic,
    },
    data() {
      return {
        dados: {
          adicionais: [],
          // loaded: false,
          loading: false,
          request: {},
          settings: {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: 0,
            centerPadding: "20px",
            responsive: [{
                breakpoint: 1440,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: false,
                  dots: true,
                },
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  initialSlide: 2,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          },
          selected: {
            nome: "",
            documento: "",
            telefone: "",
            fk_plano_id: "",
            fk_validade_id: "",
            planoValor: 0,
            documento: "",
            fantasia: "",
            cep: "",
            endereco: "",
            numero: "",
            bairro: "",
            cidade: null,
            estado: null,
            pais: "1058",
            complemento: "",
            cardName: "",
            cardNumber: "",
            cardMonth: null,
            cardYear: null,
            cardCvv: "",
            grecaptcha: "",
            adicionais: []
          },
        },
      }
    },
    computed: {
      selectedPlano() {
        return this.$store.state.plano.selectedPlano;
      },
      planos() {
        return this.$store.state.plano.publicSelect;
      },
      stepSize() {
        return (screen.width <= 992) ? 'xs' : 'sm';
      }
    },
    mounted() {
      this.$store.dispatch("getPlanosPublico")
        .then(response => {
          if (!this.$route.params.tokenId) {
            this.$router.push("/");
            return;
          } else {
            this.getData();
          }
        });
    },
    methods: {
      getData() {
        this.$store
          .dispatch("getPreCadastroPublico", this.$route.params.tokenId)
          .then((response) => {
            if (response.status == 'error') {
              toastr({
                title: response.message,
                icon: response.status,
                position: 'top-right',
                showConfirmButton: false,
                showCancelButton: false,
                html: null,
                timer: 15000
              });
              this.$router.push('/');
              return
            }
            this.dados.request = response;
            this.dados.selected.tokenId = this.$route.params.tokenId;
            let plano = this.planos.find(x => x.id == response.fk_plano_id);
            this.$store.commit("SET_PLANO_SELECTED", plano);
            this.$refs.RegisterAsign.setRecorrencia(plano.recorrencias[0]);
            this.confirm(plano);
            // (this.dados.loaded = true);
          });
      },
      getTitle(payload) {
        if (screen.width > 992) {
          return payload
        } else {
          return ''
        }
      },
      confirm(plano) {
        (this.dados.selected.nome = this.dados.request.nome);
        (this.dados.selected.documento = this.dados.request.documento);
        (this.dados.selected.telefone = (this.dados.request.telefone).replace(/[^0-9\\.]+/g, ''));
        (this.dados.selected.fk_plano_id = plano.id);
        (this.dados.selected.fk_validade_id = plano.recorrencias[0].id);
        (this.dados.selected.planoValor = plano.valor);
        (this.dados.selected.fantasia = this.dados.selected.nome);
      },
      validatePersonal() {
        return this.$refs.TabPersonal.validate();
      },
      validateCompany() {
        return this.$refs.TabCompany.validate();
      },
      validatePayment() {
        return this.$refs.TabPayment.validate();
      },
      async send() {
        let valid = await this.validatePayment();
        if (!valid) {
          return
        }
        this.dados.selected.grecaptcha = await this.$recaptcha("CadastroOffice").then(token => {
          return token;
        });
        this.dados.selected.tokenId = this.$route.params.tokenId;
        this.dados.loading = true;
        this.$store.dispatch('cadastrarOffice', this.dados.selected).then(response => {
          this.dados.loading = false;
          if (response.message) {
            toastr({
              title: response.message,
              icon: response.status,
              position: 'top-right',
              showConfirmButton: false,
              showCancelButton: false,
              html: null,
              timer: 5000
            });
          } else return
          if (response.status != 'success') return
          this.$router.push('/');
        })
      },
    }
  }
</script>

<style scoped>
  form-wizard {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .btn-wizard {
    font-size: larger;
  }

  .btn-wizard.btn-primary,
  .btn-wizard.btn-success {
    margin-right: 10vw;
  }

  @media screen and (max-width: 992px) {

    .btn-wizard.btn-primary,
    .btn-wizard.btn-success {
      margin: auto 15vw;
    }
  }
</style>